export const environment = {
  baseUrl: '',
  api: '/api/v2',
  env: 'production',
  production: true,
  stripePublishableKey: 'pk_live_JM5pSvm6deso8IkHsSfP2Edy00ulAf4ryx',
  supabaseUrl: 'https://wnlmzhxbiwktciqndfdl.supabase.co',
  supabaseKey: 'sb_publishable_VNLCE9z1rMp7lvBaHrisFg_nNFzQ2UM',
  syncfusionLicenseKey:
    'ORg4AjUWIQA/Gnt2XVhhQlJHfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5SdkZiWn9bdHxVT2Fc',
};
